<template>
  <div>
    <div style='height:100%;'>
      <nav class="a3d">
        <div class="nav-wrapper">
          <router-link :to="{name: 'Dash'}" ><img src="/static/img/siemens_logo_white.svg" class="a3d logo"></router-link>
          <div class="clear-cache" v-if="clearCacheBanner">
            Please clear your browser cache to ensure you run with the latest AM Build Optimizer<sup>TM</sup> updates!
          </div>
          <ul id="nav-mobile" class="hide-on-med-and-down a3d bold" style="height: 100%;">
            <li v-if="webGL < 1">
              <div class="webgl-warning">
                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              </div>
              <div class="webgl-warning-message-wrp">
                <div class="webgl-warning-message">WebGL is unavailable.</div>
              </div>
            </li>
            <li><router-link to="/dash/" class="menu-link">Dashboard</router-link></li>
            <li v-if="!subscription">
              <buy-credits class="menu-link"></buy-credits>
            </li>
            <li><a @click="auth.logout()" class="menu-link">Logout</a></li>
          </ul>
        </div>
        <div class="last-login right-align" v-if="user.lastLogin">
          Last login at: {{user.lastLogin.date | dateFormat}} | {{ user.lastLogin.geo}} ({{ user.lastLogin.ip}})
        </div>
      </nav>
      <!--<div class="info-banner">
        <div>
          During the Holiday break, Atlas will be making significant
          updates to Sunata. Should you have any service disruption,
          please email <a href="mailto:support@atlas3d.xyz">support@atlas3d.xyz</a>.
        </div>
        <div>Have a very Happy and Safe Holiday season!</div>
      </div>-->
      <banner></banner>
      <router-view></router-view>
      <modal name="details-submitted" height="180px" :pivotY='0.3'>
        <div class="row details-completed">
          <div class="col s12 center-align details-completed-title">
            A sales representative will contact you shortly to set up payment
          </div>
          <div class="col s12 center-align">
            <button class="a3d btn" @click="closeModal">Close</button>
          </div>
        </div>
      </modal>
      <modal name="details" height="600px" :pivotY='0.3' @before-open="modalBeforeOpen">
        <div class="row details">
          <div class="col s12">
            <div class="center-align details-title">
              Billing information
            </div>
            <div class="details-form">
              <div class="row">
                <div class="col s4 right-align details-label">Name:</div>
                <div class="col s8 details-input">
                  <input type="text" v-model="formData.name.current" @change="verifyString(formData.name, 2)">
                  <h6 class="error" v-if="formData.name.invalid">Please enter your name.</h6>
                </div>
              </div>
              <div class="row">
                <div class="col s4 right-align details-label">Company:</div>
                <div class="col s8 details-input">
                  <input type="text" v-model="formData.company.current">
                </div>
              </div>
              <div class="row">
                <div class="col s4 right-align details-label">Address:</div>
                <div class="col s8 details-input">
                  <input type="text" v-model="formData.address.current" @change="verifyString(formData.address, 2)">
                  <h6 class="error" v-if="formData.address.invalid">Please enter your address.</h6>
                </div>
              </div>
              <div class="row">
                <div class="col s4 right-align details-label">Phone:</div>
                <div class="col s8 details-input">
                  <input type="text" v-model="formData.phone.current" @change="verifyString(formData.phone, 2)">
                  <h6 class="error" v-if="formData.phone.invalid">Please enter your phone.</h6>
                </div>
              </div>
              <div class="row">
                <div class="col s4 right-align details-label">Email:</div>
                <div class="col s8 details-input">
                  <input type="text" v-model="formData.email.current" @change="verifyString(formData.email, 2)">
                  <h6 class="error" v-if="formData.email.invalid">Please enter your email.</h6>
                </div>
              </div>
              <div class="row">
                <div class="col s12 center-align">
                  <button class="a3d btn" @click="submit" v-if="!submitting">Submit</button>
                  <div class="progress" v-else>
                    <div class="indeterminate">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
  import Banner from './Banner.vue'
  import { mapState, mapGetters } from 'vuex'
  import BuyCredits from './BuyCredits'
  import errorHandling from '../mixins/errorHandling'

  export default {
    components: {
      'buy-credits': BuyCredits,
      'banner': Banner
    },
    name: 'home',
    mixins: [errorHandling],
    data: function () {
      return {
        selectedCredits: 1,
        clearCacheBanner: false,
        formData: {
          name: {last: '', current: '', invalid: false},
          company: {last: '', current: '', invalid: false},
          address: {last: '', current: '', invalid: false},
          phone: {last: '', current: '', invalid: false},
          email: {last: '', current: '', invalid: false},
          plan: '-'
        },
        submitting: false,
        submitted: false
      }
    },
    computed: {
      whichNotify () {
        // Logic later
        return '/static/img/notification_white.svg'
      },
      ...mapState([
        'user',
        'auth',
        'webGL'
      ]),
      ...mapGetters({
        subscription: 'user/subscriptionExpiration'
      })
    },
    methods: {
      modalBeforeOpen (data) {
        this.formData.name.current = `${this.user.firstName} ${this.user.lastName}`
        this.formData.email.current = this.user.email
      },
      verifyString (sString, length) {
        if (sString.current.length < length) {
          sString.current = sString.last
          sString.invalid = true
          return false
        } else {
          sString.last = sString.current
          sString.invalid = false
          return true
        }
      },
      closeModal () {
        this.$modal.hide('details-submitted')
      },
      submit () {
        const { name, company, address, phone, email, plan } = this.formData
        if (this.verifyString(name, 2) &&
          this.verifyString(address, 2) &&
          this.verifyString(phone, 2) &&
          this.verifyString(email, 2)
        ) {
          this.submitting = true
          this.$store.dispatch('billing/sendSubscriptionData', {
            name: name.current,
            company: company.current,
            address: address.current,
            phone: phone.current,
            email: email.current,
            plan
          })
            .then((response) => {
              this.resetFormData()
              this.submitted = true
              this.$modal.hide('details')
              this.$modal.show('details-submitted')
            })
            .catch((err) => {
              this.errorHandling(err, this.init)
            })
            .finally(() => {
              this.submitting = false
            })
        }
      },
      resetFormData () {
        this.formData = Object.assign(this.formData, {
          name: {last: '', current: `${this.user.firstName} ${this.user.lastName}`, invalid: false},
          company: {last: '', current: '', invalid: false},
          address: {last: '', current: '', invalid: false},
          phone: {last: '', current: '', invalid: false},
          email: {last: '', current: this.user.email, invalid: false},
          plan: '-'
        })
      },
      setIsPasswordChanged () {
        const expiresDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10)
        const isPassWasChanged = document.cookie.match(`(^|;)?${this.user.isPassWasChangedCookieName}=([^;]*)`)
        if (!isPassWasChanged) {
          document.cookie = `${this.user.isPassWasChangedCookieName}=true; expires=${expiresDate}; path=/;`
        }
      }
    },
    created () {
      this.setIsPasswordChanged()
      if (this.$route.name === 'Dash') {
        this.clearCacheBanner = true
      } else {
        this.clearCacheBanner = false
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'Dash') {
          this.clearCacheBanner = true
        } else {
          this.clearCacheBanner = false
        }
      }
    },
    filters: {
      dateFormat: function (value) {
        return new Date(value).toLocaleString({
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    }
  }
</script>

<style lang='scss' scoped>
  nav {
    height: auto;
    position: relative;

    .last-login {
      position: absolute;
      bottom: -20px;
      right: 8px;
      line-height: 18px;
      font-size: 0.85rem;
      color: #000;
      z-index: 1;
    }
  }
  .v--modal-overlay[data-modal="details-submitted"] {
    z-index: 1000;
    color: #000;

    .row.details-completed {
      width: 100%;
      padding: 50px 14px 30px 14px;

      .details-completed-title {
        padding-bottom: 20px;
      }
    }
  }
  .v--modal-overlay[data-modal="details"] {
    z-index: 1000;
    color: #000;

    .row.details {
      width: 100%;
      padding: 32px 14px 0 14px;

      .details-title {
        font-size: 1.6rem;
        font-weight: bold;
        vertical-align: center;
        padding-bottom: 20px;
      }

      .details-form {
        font-size: 1rem;
        font-weight: normal;
        width: 100%;

        .details-label {
          line-height: 36px;
        }

        .details-input {
          input {
            height: 2.4rem;
            margin-bottom: 27px;
            min-width: 100%;
            display: block;
          }
          .error {
            margin-top: -19px;
            font-size: 0.8rem;
            color: #ff0000;
          }
        }
      }
    }
  }
  .a3d {
    .nav-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 64px;
      height: auto;

      .hide-on-med-and-down {
        display: flex;

        .menu-link {
          white-space: nowrap;
        }
      }

      .clear-cache {
        word-wrap: break-word;
        font-size: 1.3em;
        line-height: 1.5;
        padding: 16px;
        text-align: center;
      }
      .webgl-warning {
        font-size: 24px;
        color: #ffc107;
        padding: 0 8px;
        position: relative;

        i {
          line-height: 24px;
          height: 24px;
        }
      }
      .webgl-warning-message-wrp {
        position: relative;
        display: none;

        .webgl-warning-message {
          position: absolute;
          min-width: 200px;
          max-width: 300px;
          transform: translateX(-100%);
          padding: 8px;
          line-height: 24px;
          text-align: center;
          top: -52px;
          left: -8px;
          margin-right: 20px;
          background-color: $atlas-blue-dark;
          border-radius: 12px;
          color: #fff;
          white-space: normal;
          z-index: 2;
          font-size: 1rem;
          font-weight: normal;

          a {
            display: inline-block;
            padding: 0;

            &:hover {
              text-decoration: underline;
              background-color: transparent;
            }
          }

          &:after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            margin-right: -5px;
            margin-top: -5px;
            width: 10px;
            height: 10px;
            background-color: $atlas-blue-dark;
            transform: rotate(45deg);
            z-index: -1;
          }
        }
      }
      .webgl-warning:hover + .webgl-warning-message-wrp {
        display: block;
      }
    }
  }

  .info-banner {
    padding: 12px 24px;
    text-align: center;
  }

  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Dash.vue?41c76d44